export const CodeBookIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path d="M19.5,4.5v-3a1,1,0,0,0-1-1H5.5a2,2,0,0,0,0,4Z" fill="#c4f0eb" />
      <path d="M3.5,2.5a2,2,0,0,0,2,2h14a1,1,0,0,1,1,1v17a1,1,0,0,1-1,1H5.5a2,2,0,0,1-2-2Z" fill="#00e6ca" />
      <path
        d="M19.5,4.5H5.5a2,2,0,0,1-2-2v3a2,2,0,0,0,2,2h14a1,1,0,0,1,1,1v-3A1,1,0,0,0,19.5,4.5Z"
        fill="#c4f0eb"
      />
      <path
        d="M5.5,2.5h11a1,1,0,0,1,1,1v1"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5,4.5v-3a1,1,0,0,0-1-1H5.5a2,2,0,0,0,0,4h14a1,1,0,0,1,1,1v17a1,1,0,0,1-1,1H5.5a2,2,0,0,1-2-2V2.5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="7.5 10.504 10 13.004 7.5 15.504"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={12.5}
        y1={14.504}
        x2={16.5}
        y2={14.504}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
